/**
 * Изменение куки в браузере на клиенте
 * @param name Название куки
 * @param value Значение
 * @param days Жизнь куки в днях
 */
export function setCookie(name, value, days) {
  document.cookie = ["".concat(name, "=").concat(encodeURIComponent(value)), 'path=/', days !== undefined ? "max-age=".concat(days * 24 * 60 * 60) : undefined].filter(Boolean).join('; ');
}

/**
 * Получение значения куки в браузере на клиенте
 * @param name Название куки
 * @returns Значение куки, если она существует, в противном случае undefined
 */
export function getCookie(name) {
  var cookies = document.cookie.split('; ');
  for (var i = 0, l = cookies.length; i < l; ++i) {
    var item = cookies[i];
    var firstEqual = item.indexOf('=');
    if (item.slice(0, firstEqual) === name) {
      return decodeURIComponent(item.slice(firstEqual + 1));
    }
  }
  return undefined;
}

/**
 * Проверка наличия куки в браузере на клиенте
 * @param name Название куки
 * @returns true, если кука существует
 */
export function hasCookie(name) {
  return document.cookie.split('; ').some(function (item) {
    return item.startsWith("".concat(name, "="));
  });
}

/**
 * Удаление куки в браузере на клиенте
 * @param name Название куки
 */
export function deleteCookie(name) {
  setCookie(name, '', -120);
}